import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const Other: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    width="230"
    height="129"
    viewBox="0 0 230 129"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
    sx={{ fill: 'none' }}
  >
    {/*eslint-disable max-len */}
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="M66 26.5h96l2-4-50-13-50 13 2 4Z"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="M158 23.5H72.22L114 12.6l44 10.9ZM66 26.5v19.12h18.83M146.5 46.5l14.97.14V26.5M167 51.5l-53-12.6-53.48 12.6 1.48 3h103.95l1.05-3ZM161.47 46.64h26.71L162 41.5"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="M66 45.62H40.37L66 40.5M68 52.5l45.76-11 46.24 10-92 1ZM161 40.5h-40M66 40.89l40.97-.39M73 32.5a1 1 0 0 1 1 1v6h-2v-6a1 1 0 0 1 1-1ZM77 32.5a1 1 0 0 1 1 1v6h-2v-6a1 1 0 0 1 1-1ZM88.5 72.5A1.5 1.5 0 0 1 90 74v7a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-7a1.5 1.5 0 0 1 1.5-1.5ZM101.5 72.5A1.502 1.502 0 0 1 103 74v7a.503.503 0 0 1-.5.5h-2a.501.501 0 0 1-.5-.5v-7a1.501 1.501 0 0 1 1.5-1.5v0ZM114.5 72.5A1.502 1.502 0 0 1 116 74v7a.503.503 0 0 1-.5.5h-2a.501.501 0 0 1-.5-.5v-7a1.501 1.501 0 0 1 1.5-1.5ZM127.5 72.5A1.502 1.502 0 0 1 129 74v7a.503.503 0 0 1-.5.5h-2a.501.501 0 0 1-.5-.5v-7a1.501 1.501 0 0 1 1.5-1.5ZM140.5 72.5A1.502 1.502 0 0 1 142 74v7a.503.503 0 0 1-.5.5h-2a.501.501 0 0 1-.5-.5v-7a1.501 1.501 0 0 1 1.5-1.5ZM85 32.5a1 1 0 0 1 1 1v6h-2v-6a1 1 0 0 1 1-1ZM89 32.5a1 1 0 0 1 1 1v6h-2v-6a1 1 0 0 1 1-1ZM139 32.5a1 1 0 0 1 1 1v6h-2v-6a.998.998 0 0 1 1-1ZM143 32.5a1 1 0 0 1 1 1v6h-2v-6a.998.998 0 0 1 1-1ZM151 32.5a1 1 0 0 1 1 1v6h-2v-6a.998.998 0 0 1 1-1ZM155 32.5a1 1 0 0 1 1 1v6h-2v-6a.998.998 0 0 1 1-1ZM100 32.5a1 1 0 0 1 1 1v6h-2v-6a1 1 0 0 1 1-1ZM128 32.5a1 1 0 0 1 1 1v6h-2v-6a.998.998 0 0 1 1-1ZM62 54.5v4.33h104l-.05-4.33M41 46.5v8l-2 1 2 4.11v35.94h19.52M186.63 47v7.5l2.37 1-2 3v36.17h-19.17M166 54.5h21M40 54.5h21M187 57.5h-21M61 57.5H40M166 60.5h21M41 60.5h21M132.36 58.83 134 62.5h3.17l1.24-3.67M138 92.4l-.83-29.9H134l-1.06 29.9H138ZM139 94.67l-1-2.27h-5.06l-1.16 2.27H139ZM118.36 58.83 120 62.5h3.17l1.24-3.67M124 92.4l-.83-29.9H120l-1.06 29.9H124ZM125 94.67l-1-2.27h-5.06l-1.16 2.27H125ZM104.36 58.83 106 62.5h3.17l1.24-3.67M110 92.4l-.83-29.9H106l-1.06 29.9H110ZM111 94.67l-1-2.27h-5.06l-1.16 2.27H111ZM90.36 58.83 92 62.5h3.17l1.24-3.67M96 92.4l-.83-29.9H92l-1.06 29.9H96ZM97 94.67l-1-2.27h-5.06l-1.16 2.27H97ZM75.36 58.83 77 62.5h3.17l1.24-3.67M81 92.4l-.83-29.9H77l-1.06 29.9H81ZM82 94.67l-1-2.27h-5.06l-1.16 2.27H82ZM62.36 58.83 64 62.5h3.17l1.24-3.67M68 92.4l-.83-29.9H64l-1.06 29.9H68ZM69 94.67l-1-2.27h-5.06l-1.16 2.27H69ZM146.36 58.83 148 62.5h3.17l1.24-3.67M152 92.4l-.83-29.9H148l-1.06 29.9H152ZM153 94.67l-1-2.27h-5.06l-1.16 2.27H153ZM160.36 58.83 162 62.5h3.17l1.24-3.67M166 92.4l-.83-29.9H162l-1.06 29.9H166ZM167 94.67l-1-2.27h-5.06l-1.16 2.27H167ZM114 22.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM111 39.5l-2-3-2 3 1-3-2-2-2 1 2-1 .01-2.5-1.01-.5 2-1 1 1v2l2 1 1-2-1-1 1-2 1 1 2-2v-1.35l.78 1.99.22.36v3h1l1-3 2 1-2 1-.04 1.82 1.04.99 2 .19v-3l2-2 1 2h-1v1l1 2h-2l-1 2v3h-3"
    />
    <path
      fill="#fff"
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m209.101 69.395-61.112 5.733 3.088 32.906 61.111-5.734-3.087-32.905Z"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m180.56 76.814-18.807 1.765 1.617 17.234 18.807-1.764-1.617-17.235ZM158.96 74.09l.14 1.49"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeDasharray="2.73 2.73"
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m159.36 78.3 2.42 25.84"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m161.91 105.5.14 1.5M164.13 99.69l14.89-1.4M195.25 81.75l10.97-1.03M193.05 83.54l16.45-1.55M196.33 84.81l9.4-.88M164.03 102.86l26.64-2.5"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="m199.96 74.19-6.49 3.77 13.56-1.27-7.07-2.5Z"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m196.45 77.68.37 3.92M199.06 77.44l.37 3.92M201.67 77.19l.37 3.92M204.32 77.34l.29 3.13"
    />
    <path
      fill="#fff"
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m209.353 65.784-59.852 13.61 7.328 32.227 59.852-13.61-7.328-32.227Z"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="M182.019 76.837 163.6 81.025l3.838 16.88 18.419-4.19-3.838-16.878ZM160.24 76.95l.34 1.46"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeDasharray="2.73 2.73"
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m161.18 81.08 5.76 25.31"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m167.24 107.72.33 1.46M168.69 101.66l14.58-3.31M197.22 79.84l10.74-2.44M195.27 81.9l16.11-3.66M198.68 82.74l9.21-2.1M169 104.82l26.09-5.93"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="m200.91 71.74-5.95 4.58 13.28-3.02-7.33-1.56Z"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeMiterlimit="10"
      strokeWidth=".75"
      d="m197.88 75.66.87 3.83M200.44 75.07l.87 3.84M203 74.49l.87 3.84M205.64 74.3l.7 3.06"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="M217.87 95.53c4 1.87 6.13 3.88 6.13 6 0 9.94-48.8 18-109 18S6 111.44 6 101.5c0-4.67 10.76-8.92 28.42-12.12"
    />
    <path
      stroke={props.fill || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".75"
      d="M150 95.5H52v3h98v-3ZM150 98.5H46v3h104v-3Z"
    />
  </SvgIcon>
);

export default Other;
